var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import Emitter from '../utils/emitter';
import LocalDb from '../model/local-db';
import ArrayPro from '../utils/array-pro';
import debounce from 'lodash/debounce';
import { decorator } from '../utils/instance';
var canSetAttr = ['syncId', 'syncNamespace', 'nodeId', 'startTime'];
var SessionDB = (function (_super) {
    __extends(SessionDB, _super);
    function SessionDB(config) {
        var e_1, _a;
        var _this = _super.call(this) || this;
        _this.syncId = 0;
        _this.nodeId = 1;
        _this.startTime = -1;
        _this.syncNamespace = 0;
        _this.config = config;
        var sessionConfig = {};
        var MID = /\.aliexpress\.com$/.test(window.location.host);
        if (MID) {
            sessionConfig = config.disableSessionSort ? {} : { order: 'viewModifyTime', isAcs: false, max: 5000 };
        }
        else {
            sessionConfig = config.disableSessionSort ? {} : { order: 'viewModifyTime', isAcs: false };
        }
        _this._list = new ArrayPro(sessionConfig);
        _this.debounceSaveDb = debounce(function () {
            _this.saveToDb();
            _this.emit('session_update');
        }, config.delayTime);
        _this._db = new LocalDb("im-sdk-slist-" + config.userId + "-" + config.region + "-" + config.lang + "-" + config.channel);
        var data = _this._db.get();
        if (data && data.list) {
            try {
                for (var _b = __values(data.list), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    _this._list.set(item.sessionId, item, 'back');
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
            _this.setAttr(data);
            _this.emit('session_update');
        }
        return _this;
    }
    SessionDB.prototype.setAttr = function (obj, val) {
        var _a, e_2, _b;
        if (typeof obj === 'string') {
            obj = (_a = {}, _a[obj] = val, _a);
        }
        try {
            for (var canSetAttr_1 = __values(canSetAttr), canSetAttr_1_1 = canSetAttr_1.next(); !canSetAttr_1_1.done; canSetAttr_1_1 = canSetAttr_1.next()) {
                var key = canSetAttr_1_1.value;
                if (obj[key] != null) {
                    this[key] = parseInt(obj[key]);
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (canSetAttr_1_1 && !canSetAttr_1_1.done && (_b = canSetAttr_1.return)) _b.call(canSetAttr_1);
            }
            finally { if (e_2) throw e_2.error; }
        }
    };
    SessionDB.prototype.set = function (sessionViewData, type) {
        this._list.set(sessionViewData.sessionId, sessionViewData, type);
        this.debounceSaveDb();
    };
    SessionDB.prototype.get = function (sessionId) {
        return this._list.get(sessionId);
    };
    SessionDB.prototype.getAll = function () {
        return this._list.getAll();
    };
    SessionDB.prototype.delete = function (sessionId) {
        this._list.remove(sessionId);
        this.saveToDb();
        this.emit('session_update');
    };
    SessionDB.prototype.clean = function () {
        this._list.clear();
        this._db.remove();
        this.syncId = 0;
        this.nodeId = 1;
        this.startTime = -1;
        this.syncNamespace = 0;
    };
    SessionDB.prototype.saveToDb = function () {
        this._db.save({
            startTime: this.startTime,
            syncNamespace: this.syncNamespace,
            syncId: this.syncId,
            nodeId: this.nodeId,
            list: this.getAll(),
        });
    };
    SessionDB.prototype.markExpired = function () {
        var _this = this;
        debounce(function () {
            _this._db.markExpired();
        }, this.config.delayTime)();
    };
    SessionDB = __decorate([
        decorator
    ], SessionDB);
    return SessionDB;
}(Emitter));
export default SessionDB;
